import React, { useState } from "react";
import { Route, Routes } from "react-router-dom";
import { Container } from "./UserManagement.styled";
import { Breadcrumb } from "./components";
import { Main, InviteUsers, Users, Roles, Finish, CreateRole, DetailsPermissions } from "./pages";
import { Alert } from "@ann/web-components";
import { useUserManagementBreadcrumbs } from "./hooks/useUserManagementBreadcrumbs";

const UserManagement = () => {
  const { items: breadcrumbItems, helpers: breadcrumbHelpers } = useUserManagementBreadcrumbs();

  const [inviteError, setInviteError] = useState(null);
  const [invitedUsersCount, setInvitedUsersCount] = useState(0);

  return (
    <Container>
      {/* <Breadcrumb items={breadcrumbItems} /> */}
      {inviteError && (
        <Alert
          severity="error"
          description={inviteError.message}
          closable
          onClose={() => setInviteError(null)}
          style={{ marginBottom: "16px" }}
        />
      )}
      <Routes>
        <Route
          path="invite-user/*"
          element={
            <InviteUsers
              breadcrumbHelpers={breadcrumbHelpers}
              inviteError={inviteError}
              setInviteError={setInviteError}
              setInvitedUsersCount={setInvitedUsersCount}
            />
          }
        />
        <Route path="permissions/:permissionId/*" element={<DetailsPermissions breadcrumbHelpers={breadcrumbHelpers}/>} />
        <Route path="users/:userId/*" element={<Users breadcrumbHelpers={breadcrumbHelpers}/>} />
        <Route path="roles/:roleId/*" element={<Roles breadcrumbHelpers={breadcrumbHelpers}/>} />
        <Route path="create-role/*" element={<CreateRole breadcrumbHelpers={breadcrumbHelpers} />} />
        <Route path="finish" element={<Finish breadcrumbHelpers={breadcrumbHelpers} invitedUsersCount={invitedUsersCount} />} />
        <Route path="/*" element={<Main breadcrumbHelpers={breadcrumbHelpers} />} />
      </Routes>
    </Container>
  );
};

export default UserManagement;

